"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapStateToProps = exports.NoticeContainer = void 0;
var _reactRedux = require("react-redux");
var _NoticeContainer = require("./NoticeContainer");
var _selectors = require("./selectors");
const mapStateToProps = state => ({
  notice: (0, _selectors.noticeSelector)(state)
});
exports.mapStateToProps = mapStateToProps;
const NoticeContainer = exports.NoticeContainer = (0, _reactRedux.connect)(mapStateToProps)(_NoticeContainer.NoticeContainer);